export default __webpack_public_path__ + "static/media/startup-icon.502178f2.svg";